import { createGlobalStyle } from 'styled-components';

import { COLORS } from 'components-stateless/colors';
import { COLOURS_AA } from 'components-stateless/DesignSystem/Atoms/Colours';

const GlobalStyle = createGlobalStyle`
  *{
    font-family: 'Inter', 'Open Sans', Arial, Helvetica, sans-serif;
    box-sizing: border-box;
  }

  // IMPORTANT: DO NOT CHANGE
  html,
  body {
    height: 100%;
    width: 100%;
  }

  // IMPORTANT: DO NOT CHANGE
  #app {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;
  }

  textarea {
    border-width: 0px;
  }

  /* Resets */
  h1, h2, h3, h4, h5, label, p, span {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    text-rendering: optimizeLegibility;
    letter-spacing: normal;
  }

  h1 {
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 40px;
    color: ${COLOURS_AA.text.SectionHeading};
  }

  h2 {
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: ${COLOURS_AA.text.SectionHeading};
  }

  h3 {
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: ${COLOURS_AA.text.SectionHeading};
  }

  h4 {
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    color: ${COLOURS_AA.text.SectionHeading};
  }

  blockquote {
    font-family: 'Inter';
    font-style: 'italic';
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.04em;
  }

  p {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${COLOURS_AA.text.StandardTxt};
  }

  label {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${COLOURS_AA.neutralBG.BgGrey700};
  }

  caption {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    color: ${COLOURS_AA.text.InputMsgDefault};
  }

  .active {
    color: ${COLORS.GREEN} !important;
  }

  button {
    border: none;
    border-radius: 3px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  kbd {
    padding: 0.1em 0.6em;
    border: 1px solid #ccc;
    font-size: 11px;
    font-family: Arial,Helvetica,sans-serif;
    background-color: #f7f7f7;
    color: #333;
    -moz-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2),0 0 0 2px #ffffff inset;
    -webkit-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2),0 0 0 2px #ffffff inset;
    box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2),0 0 0 2px #ffffff inset;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    display: inline-block;
    margin: 0 0.1em;
    text-shadow: 0 1px 0 #fff;
    line-height: 1.4;
    white-space: nowrap;
  }

  /* Text alignment classes for rich text content */
  .align-left {
    text-align: left;
  }

  .align-center {
    text-align: center;
  }

  .align-right {
    text-align: right;
  }

  // Global style on mobile devices for display tooltip title
  @media (pointer: coarse), (hover: none) {
    span[title]{
      position: relative;
      display: inline-flex;
      justify-content: center
    }
    span[title]:hover:after {
      content: attr(title);
      position: absolute;
      z-index: 1400;
      top: 90%;
      color: #000;
      background-color: #fff;
      border: 1px solid #ddd;
      width: fit-content;
      padding: 3px;
    }
    [title]:focus:after {
      content: attr(title);
      position: absolute;
      z-index: 1400;
      top: 90%;
      color: #000;
      background-color: #fff;
      border: 1px solid;
      width: fit-content;
      padding: 3px;
    }
  }
`;

export default GlobalStyle;
